/*
 * Copyright (c) 2020. FINN Sp. z o.o.
 */

package pl.finn.forms.wouip

import io.kvision.navigo.Navigo
import io.kvision.routing.Routing
import pl.finn.forms.App
import pl.finn.forms.utils.stringProperty

fun Routing.wouipRouting(app: App): Navigo {
    return on("/wniosek_o_udostepnienie_informacji_publiczbnej_nowy/:token", { params ->
        Model.nowy(stringProperty(params, "token"), app)
    }).on("/wniosek_o_udostepnienie_informacji_publiczbnej_edycja/:token", { params ->
        Model.edycja(stringProperty(params, "token"), app)
    })
}
